import { Typography, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { createOrUpdateShape } from "orion-components/GlobalData/Actions";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getDir } from "orion-components/i18n/Config/selector";
import { Translate, getTranslation } from "orion-components/i18n";

const CustomizedTextField = styled(TextField)({
	"& label": {
		color: "#9A9FA3",
		fontSize: 12
	},
	"& label.Mui-focused": {
		color: "#9A9FA3"
	},
	"& .MuiOutlinedInput-root": {
		"& fieldset": {
			borderColor: "#5E6571"
		},
		"&:hover fieldset": {
			borderColor: "#4DB5F4"
		},
		"&.Mui-focused fieldset": {
			borderColor: "#4DB5F4"
		}
	}
});

const Details = ({ shapeName, shapeType }) => {
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const dispatch = useDispatch();
	const { mapTools } = useSelector(state => state.mapState);
	const dir = useSelector(state => getDir(state));

	useEffect(() => {
		const { feature } = mapTools;
		if (feature) {
			const { properties } = feature;
			const { name, description } = properties;
			dispatch(createOrUpdateShape(shapeType, { name, description }));
			setName(name);
			setDescription(description);
		}
	}, []);

	return (
		<div
			style={{
				marginTop: 24,
				width: 388,
				...(dir === "ltr" && { marginLeft: 20, marginRight: 32.31 }),
				...(dir === "rtl" && { marginRight: 20, marginLeft: 32.31 })
			}}
		>
			<Typography
				sx={{
					fontSize: 14,
					fontFamily: "Roboto",
					letterSpacing: 0,
					color: "#FFFFFF",
					opacity: "1",
					textAlign: dir === "ltr" ? "left" : "right"
				}}
			>
				<Translate value="global.sharedComponents.shapeEditor.components.shared.details.header" />
			</Typography>
			<div style={{ marginTop: 16 }}>
				<div
					style={{
						fontSize: 11,
						fontFamily: "Roboto",
						letterSpacing: 0,
						opacity: "1",
						marginBottom: 5.5,
						textAlign: dir === "ltr" ? "left" : "right",
						display: "flex"
					}}
				>
					<p
						style={{
							color: "#D3615C",
							width: 7,
							height: 13,
							...(dir === "ltr" && { marginRight: 5 }),
							...(dir === "rtl" && { marginLeft: 5 }),
							marginTop: "-4px"
						}}
					>
						&#9913;
					</p>
					<p
						style={{
							color: "#9A9FA3"
						}}
					>
						<Translate value="global.sharedComponents.shapeEditor.components.shared.details.name" />
					</p>
				</div>
				<CustomizedTextField
					placeholder={shapeName}
					variant="outlined"
					name="name"
					value={name}
					fullWidth
					onChange={e => {
						setName(e.target.value);
						dispatch(createOrUpdateShape(shapeType, { name: e.target.value }));
					}}
					inputProps={{ style: { color: "#FFFFFF", fontSize: 12, fontFamily: "Roboto" } }}
				/>
			</div>
			<div style={{ marginTop: 16 }}>
				<p
					style={{
						fontSize: 11,
						fontFamily: "Roboto",
						letterSpacing: 0,
						color: "#9A9FA3",
						opacity: "1",
						textAlign: dir === "ltr" ? "left" : "right",
						...(dir === "ltr" && { marginLeft: 5.95 }),
						...(dir === "rtl" && { marginRight: 5.95 }),
						marginBottom: 5.5
					}}
				>
					<Translate value="global.sharedComponents.shapeEditor.components.shared.details.description" />
				</p>
				<CustomizedTextField
					placeholder={getTranslation(
						"global.sharedComponents.shapeEditor.components.shared.details.descriptionHere"
					)}
					variant="outlined"
					name="description"
					value={description}
					onChange={e => {
						setDescription(e.target.value);
						dispatch(createOrUpdateShape(shapeType, { description: e.target.value }));
					}}
					multiline={true}
					fullWidth
					rows={4}
					inputProps={{ style: { color: "#FFFFFF", fontSize: 12, fontFamily: "Roboto" } }}
				/>
			</div>
		</div>
	);
};

Details.propTypes = {
	shapeName: PropTypes.string.isRequired,
	shapeType: PropTypes.string.isRequired
};

export default Details;
